import { VisitNodePassage } from "../../types";
export const fillMissingMeasuresVisitor = (measures) => (args) => {
    if (args?.context?.visitNodePassage !== VisitNodePassage.Leaf) {
        return;
    }
    if (args.visitable.measures) {
        for (const measure of measures) {
            if (!(measure in args.visitable.measures)) {
                args.visitable.measures[measure] = "-";
            }
        }
    }
};
